'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOCAL_STORAGE_REMOVE_ITEM = exports.LOCAL_STORAGE_REMOVE_ITEM = '@@localStorage/REMOVE_ITEM';
var LOCAL_STORAGE_SET_ITEM = exports.LOCAL_STORAGE_SET_ITEM = '@@localStorage/SET_ITEM';


//////////////////
// WEBPACK FOOTER
// ./~/redux-module-local-storage/build/actionTypes.js
// module id = 182
// module chunks = 0